import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "slices/thunk";
import { Navigate } from "react-router-dom";
import { RootState } from "slices";
import { createSelector } from 'reselect';

const Logout: React.FC = () => {

    const dispatch = useDispatch<any>();

    const selectLogout = createSelector(
        (state: RootState) => state.Login,
        (login) => ({
            isAuthenticated: login.isAuthenticated
        })
    );

    const { isAuthenticated } = useSelector(selectLogout);

    React.useEffect(() => {
        dispatch(logoutUser());
    }, [dispatch]);

    // Redirect to login if not authenticated (after logout)
    return !isAuthenticated ? <Navigate to="/login" /> : null;
}

export default Logout;
